import React from "react";
import { api } from "../lib/api";

/**
 * Catches render crashes so a single broken component shows a recovery card instead
 * of a blank white page, and reports the stack so failures are visible in the admin
 * error log rather than only in a user's console.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Best-effort: if reporting itself fails there is nothing useful left to do,
    // and throwing here would replace the recovery UI with a blank page.
    api.reportError({
      message: String(error?.message || error).slice(0, 500),
      stack: String(info?.componentStack || error?.stack || "").slice(0, 4000),
      path: window.location.pathname,
    }).catch(() => {});
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-[60vh] flex items-center justify-center p-6" data-testid="error-boundary">
        <div className="card p-6 max-w-md text-center">
          <h2 className="font-heading font-semibold text-lg">Something went wrong</h2>
          <p className="text-sm text-slate-500 mt-2">
            This page hit an unexpected error. It has been reported automatically.
          </p>
          <div className="flex gap-2 justify-center mt-5">
            <button className="btn-outline" onClick={() => this.setState({ error: null })}>
              Try again
            </button>
            <button className="btn-primary" onClick={() => { window.location.href = "/"; }}>
              Back to dashboard
            </button>
          </div>
        </div>
      </div>
    );
  }
}
